import { reactive } from "vue";
import { api } from "../api.js";

var defaults = {
	loading: false,
	saving: false,
	error: null,
	data: null,
	dirty: null,
};

var configStore = {
	data: reactive({ ...defaults }),
	methods: {
		load: async function () {
			configStore.data.loading = true;
			try {
				var res = await api.get("/api/config");
				configStore.data.data = res;
				configStore.data.dirty = { ...res };
				configStore.data.error = null;
			} catch (e) {
				configStore.data.error = e.message;
			} finally {
				configStore.data.loading = false;
			}
		},
		save: async function () {
			configStore.data.saving = true;
			try {
				var patch = { ...configStore.data.dirty };
				var res = await api.put("/api/config", patch);
				configStore.data.data = res;
				configStore.data.dirty = { ...res };
				configStore.data.error = null;
			} catch (e) {
				configStore.data.error = e.message;
			} finally {
				configStore.data.saving = false;
			}
		},
		reset: function () {
			if (configStore.data.data) {
				configStore.data.dirty = { ...configStore.data.data };
			}
		},
		clearStore: function () {
			Object.assign(configStore.data, defaults);
		},
	},
};

export default configStore;
